import { LaneInput } from '@kinetic-ui/data-layer';
import { recoilKeys } from 'const';
import { atom, useRecoilState } from 'recoil';
import { RecursivePartial } from 'types/util';

export const selectedLaneState = atom<RecursivePartial<LaneInput> | undefined>({
  key: recoilKeys.SELECTED_LANE,
  default: undefined,
});

export const useSelectedLane = () => {
  const [selectedLane, setSelectedLane] = useRecoilState(selectedLaneState);

  return { selectedLane, setSelectedLane };
};
